'use client';
import { populateSiteConfig } from './siteConfig/siteConfigSlice.js';
import { getConsentThunk } from './consent/consentSlice.js';
import { getComponentTrackingNames } from '../tracking/helpers/constants.js';
import { getOptimizelyAbTrackingString } from '../tools/optimizely.js';
export const initializeApp = ({ config, context, locales, params, }) => async (dispatch) => {
    try {
        dispatch(populateSiteConfig({
            loginregistration: config,
            locales: locales,
            platformType: context.platformSite,
            device: context.device,
            currentLocale: context.locale,
            configInitialized: true,
            encodedGTLibraryUrl: params && 'encodedGTLibraryUrl' in params
                ? params.encodedGTLibraryUrl
                : undefined,
        }));
        dispatch(getConsentThunk());
    }
    catch (error) {
        console.error('Error:', error);
    }
};
export const sendGlobalTrackingThunk = (trackingCallback, additionalTrackingParams) => async (_, getState) => {
    const state = getState();
    const { loginSource } = state.core.sourceData;
    const { navigationContext, activeForm } = state.core.navigation;
    if (!window || !window?.stst_gt) {
        console.error('Error: window.stst_gt is not available.');
    }
    const trackingPayload = {
        pageName: window?.utag_data?.pageName,
        loginSource,
        componentTitle: getComponentTrackingNames(navigationContext, activeForm),
    };
    const builtTrackingPayload = trackingCallback({
        ...trackingPayload,
        ...additionalTrackingParams,
    });
    const payloadWithOptimizely = {
        ...builtTrackingPayload,
        trackingData: {
            ...builtTrackingPayload.trackingData,
            abTestClientSide: getOptimizelyAbTrackingString(),
            abTestServerSide: '',
        },
    };
    // move to helper
    window.stst_gt &&
        window.stst_gt.methods.sendCustomEvent(payloadWithOptimizely.method, payloadWithOptimizely.triggeringEventPlace, payloadWithOptimizely.trackingData);
};
//# sourceMappingURL=thunks.js.map